import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import FBACredentials from "./FBA/FBACredentials";
import FBAArticles from "./FBA/FBAArticles";
import FBAConfigurationTab from "./FBA/FBAConfiguration";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const ShopifyTab = ({ initialSku = null, onNavConsumed, onNavigateToBase }) => {
  const [shopifySubTab, setShopifySubTab] = useState(1);

  React.useEffect(() => {
    if (initialSku) {
      setShopifySubTab(1);
    }
  }, [initialSku]);

  const handleShopifySubTabChange = (event, newValue) => {
    setShopifySubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={shopifySubTab}
              onChange={handleShopifySubTabChange}
              aria-label="credentials tabs"
            >
              <Tab label="Credentials" />
              <Tab label="Articles" />
              <Tab label="Configuration" />
            </Tabs>
          </Box>

          {/* FBA Credentials Tab */}
          <TabPanel value={shopifySubTab} index={0}>
            <FBACredentials />
          </TabPanel>
          {/* Articles Tab */}
          <TabPanel value={shopifySubTab} index={1}>
            <FBAArticles
              initialSku={initialSku}
              onSkuConsumed={onNavConsumed}
              onNavigateToBase={onNavigateToBase}
            />
          </TabPanel>
          {/* Configuration Tab */}
          <TabPanel value={shopifySubTab} index={2}>
            <FBAConfigurationTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ShopifyTab;
